import React from "react";
import { Box } from "@chakra-ui/react";

function Deal() {
  return <Box>Deals Page</Box>;
}

export default Deal;
